import { Tag } from '../../../../../../common/tags/tagTypes';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { tagPathDisplaySelector } from '../../../../../element/tags/tagPathDisplaySelector';

const useTagPopupsState = (openModal: () => void) => {
    const [currentlyEditingTag, setCurrentlyEditingTag] = useState<Tag | null>(null);
    const rootPaths = useSelector(tagPathDisplaySelector);
    const { userRootPath, shareRootPath } = rootPaths || {};

    const handleClickEdit = (tag: Tag) => {
        setCurrentlyEditingTag(tag);
        openModal();
    };

    return {
        currentlyEditingTag,
        setCurrentlyEditingTag,
        userRootPath,
        shareRootPath,
        handleClickEdit,
    };
};

export default useTagPopupsState;
